export default () => ({
  clinicalBackgrounds: undefined,
  summary: undefined,
  triage: undefined,
  timeline: undefined,
  liteProfile: undefined
})
